import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
  effect,
} from '@angular/core';
import { OrganService } from '../../core/services/organ.service';

type OrganAccessType = 'self_assessment' | 'evaluation';

@Directive({
  selector: '[hasOrganAccess]',
  standalone: true,
})
export class HasOrganAccessDirective {
  private readonly templateRef = inject(TemplateRef<any>);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly organService = inject(OrganService);

  private accessType: OrganAccessType | null = null;
  private isVisible = false;

  constructor() {
    effect(() => {
      this.organService.selectedOrganId();
      this.updateView();
    });
  }

  @Input() set hasOrganAccess(access: OrganAccessType | null) {
    this.accessType = access;
    this.updateView();
  }

  private updateView(): void {
    const allowed = this.checkAccess();
    if (allowed && !this.isVisible) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isVisible = true;
    } else if (!allowed && this.isVisible) {
      this.viewContainer.clear();
      this.isVisible = false;
    }
  }

  private checkAccess(): boolean {
    if (!this.accessType) return true;
    const organ = this.organService.selectedOrgan();
    if (!organ) return false;
    if (organ.is_admin_user) return true;
    if (this.accessType === 'self_assessment') {
      return !!organ.can_do_evaluation;
    }
    if (this.accessType === 'evaluation') {
      return true;
    }
    return true;
  }
}
